import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PaygSummaryModel } from '../models/payg/payg-summary.model';
import { PaygPaymentTypeModel } from '../models/payg/payg-payment-type.model';
import { PaygCumulativeCreditStatusModel } from '../models/payg/payg-cumulative-credit-status.model';
import { PaygPaymentTransmissionPerformanceModel } from '../models/payg/payg-payment-transmission-performance.model';

@Injectable()
export class PaygService {

  private firstQueryString: boolean = false;

  constructor(private http: HttpClient, @Inject('API_BASE_URL') private baseUrl: string) { }

  getSummary(clientId: number, siteId: number): Promise<any> {
    let url = this.baseUrl + 'payg/summary/' + clientId.toString();

    if (siteId == 0) siteId = null;
    if (siteId) url = url + '?siteId=' + siteId.toString();

    let promise = new Promise((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(res => {
          var data = (res as PaygSummaryModel);
          resolve(data);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: "Could not get PAYG summary."
          });
        });
    });

    return promise;
  }

  getPaymentByType(clientId: number, siteId: number, timePeriod: string): Promise<any> {
    let url = this.baseUrl + 'payg/paymentsbytype/' + clientId.toString();

    this.firstQueryString = true;

    if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
    if (timePeriod) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

    let promise = new Promise((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(res => {
          var data = (res as PaygPaymentTypeModel[]);
          resolve(data);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: "Could not get PAYG summary."
          });
        });
    });

    return promise;
  }

  getCumulativeCreditStatus(clientId: number, siteId: number, timePeriod: string): Promise<any> {
    let url = this.baseUrl + 'payg/cumulativecreditstatus/' + clientId.toString();

    this.firstQueryString = true;

    if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
    if (timePeriod) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

    //if (siteId == 0) siteId = null;
    //if (siteId || timePeriod) url = url + '?';
    //if (siteId) url = url + 'siteId=' + siteId.toString();
    //if (siteId && timePeriod) url = url + '&';
    //if (timePeriod) url = url + 'timePeriod=' + timePeriod;

    let promise = new Promise((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(res => {
          var data = (res as PaygCumulativeCreditStatusModel[]);
          resolve(data);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: "Could not get PAYG summary."
          });
        });
    });

    return promise;
  }

  getPaymentTransmissionPerformance(clientId: number, siteId: number, timePeriod: string): Promise<any> {
    let url = this.baseUrl + 'payg/paymenttransmissionperformance/' + clientId.toString();

    this.firstQueryString = true;

    if (siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
    if (timePeriod) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

    let promise = new Promise((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(res => {
          var data = (res as PaygPaymentTransmissionPerformanceModel[]);
          resolve(data);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: "Could not get PAYG summary."
          });
        });
    });

    return promise;
  }

  private createQueryStringParameter(key: string, value: string) {
    var val = this.firstQueryString ? "?" : "&";
    this.firstQueryString = false;
    return val.concat(key).concat("=".concat(value));
  }
}
